class WIquickAdd extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback() {
        this.clickOnSingleVariant();
    }
    clickOnSingleVariant() {
        let varBtn = this.querySelectorAll('.WI_quickAdd_atc');
        varBtn.forEach(variant => {
            variant.addEventListener('click', async (e)=>{
                e.preventDefault();
              //console.log('e',e);
              // e.classList.add('loading');
              var WI_quickAdd_in = variant.closest('.WI_quickAdd_in');
              WI_quickAdd_in.classList.add('loading');

                let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
                let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
                if (loadingCartBlock != null) {
                    loadingCartBlock.style.display = "block";
                }
                if (emptyCart != null) {
                    emptyCart.style.display = "none";
                }
                const openCart = new CustomEvent("opencart", { bubbles: true });
                document.dispatchEvent(openCart);
                let variantId = variant.getAttribute('data-variantid');
                let formData = {
                    'items': [{
                        "id": variantId,
                        "quantity": 1
                    }]
                };
                await fetch('/cart/add',{
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });   
                // const updateCart = new CustomEvent("updateCart", { bubbles: true });
                // document.dispatchEvent(updateCart);
              WI_quickAdd_in.classList.remove('loading');
              
               document.dispatchEvent(new CustomEvent('cart:build'));
              let cDrawer = document.querySelector("#CartDrawer");
              if( !cDrawer.classList.contains("drawer--is-open") )
              {
                document.querySelector(".js-drawer-open-cart").click();
              }
            });
        });
    };
}

customElements.define("wi-quickadd", WIquickAdd);